module.exports = __webpack_public_path__ + "img/20240920072510018r31.8f107087.jpg";